export const DEFECT_TABLE_KEY = 'defect_sort';
export const NO_DEFECT_TABLE_KEY = 'no_defect_sort';

export const COLUMN_FIELD_ACCESSORS = {
  diagnosis: item => item.diagnosis?.[0]?.mkb_code ?? '',
  // можно добавить  другие поля:
};

export const getSortedCases = (cases, sortParam) => {
  if (!sortParam) return cases;

  const [sortId, sortOrder] = sortParam.split(':');

  return [...cases].sort((a, b) => {
    const getValue = COLUMN_FIELD_ACCESSORS[sortId]
      ? COLUMN_FIELD_ACCESSORS[sortId]
      : item => item?.[sortId];

    const aValue = getValue(a);
    const bValue = getValue(b);

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    }

    const result = String(aValue ?? '').localeCompare(
      String(bValue ?? ''),
      ['ru', 'en'],
      {
        sensitivity: 'base', // игнорируем регистр и диакритику
        ignorePunctuation: true, // игнорируем знаки препинания
        numeric: true, // если есть числа в строках — сравниваем их "по-человечески"
      },
    );

    return result * (sortOrder === 'asc' ? 1 : -1);
  });
};
